import { motion } from 'framer-motion';
import VideoPlayer from '../../common/VideoPlayer';
import { FadeInUp, ParallaxElement } from '../../common/AnimationUtils';

import styles from '../styles/FeatureRow.module.css';

const FeatureRow = ({ title, description, imageSrc, reversed = false, videoSrc, shouldLoad = true, onVideoLoad }) => {
    return (
        <div className={`${styles.row} ${reversed ? styles.reversed : ''}`}>
            <FadeInUp
                className={styles.textContent}
                delay={0.2}
                style={{
                    textAlign: reversed ? "right" : "left",
                }}
            >
                <h3 className={styles.title}>{title}</h3>
                <p className={styles.description}>{description}</p>
            </FadeInUp>

            <div className={styles.mediaContent}>
                <ParallaxElement offset={30}>
                    <motion.div
                        className={styles.mediaWrapper}
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        whileHover={{ scale: 1.02, transition: { duration: 0.3 } }}
                    >
                        {videoSrc && shouldLoad ? (
                            <VideoPlayer
                                src={videoSrc}
                                onCanPlay={onVideoLoad}
                            />
                        ) : (
                            imageSrc ? (
                                <img src={imageSrc} alt={title} className={styles.image} />
                            ) : (
                                // Show placeholder if video shouldn't load yet or if no media
                                <div className={styles.placeholder}>
                                    {videoSrc ? "Loading Video..." : "Image Placeholder"}
                                </div>
                            )
                        )}
                    </motion.div>
                </ParallaxElement>
            </div>
        </div>
    );
};

export default FeatureRow;
